import Button from 'common/components/buttons/button';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import { useDispatch, useSelector } from 'react-redux';
import {
  onRuleRemoved,
  onTargetAdded,
  selectRules,
  selectRuleTargets
} from '../segmentation-config.slice';
import { RootState } from 'app/store';
import { DropDownItemType } from 'common/components/drop-downs/legacy/dropDownItemType';
import SegmentationConfigRuleTarget from './segmentation-config-rule-target';
import { Rule } from '../segmentation-config.types';

interface SegmentationConfigRuleProps {
  rule: Rule;
  operatorDropDownItems: DropDownItemType[];
  targetTypeDropDownItems: DropDownItemType[];
}

export default function SegmentationConfigRule({
  rule,
  operatorDropDownItems,
  targetTypeDropDownItems
}: SegmentationConfigRuleProps) {
  const dispatch = useDispatch();

  const rules = useSelector((state: RootState) => selectRules(state));
  const targets = useSelector((state: RootState) => selectRuleTargets(state));

  const removeRule = (ruleKey: number) => {
    dispatch(onRuleRemoved({ ruleKey }));
  };

  const addTarget = (ruleKey: number) => {
    dispatch(onTargetAdded({ ruleKey }));
  };

  return (
    <div className="min-h-fit bg-white border rounded border-neutral-200 p-4 shadow-lg shadow-secondary-200/10">
      <div className="flex justify-end" key={'rule-'}>
        <div className="flex items-center gap-4">
          <Button
            onClick={() => removeRule(rule.id)}
            isDisabled={rules.length === 1}
            theme={ButtonTheme.MINIMAL}
            identifier={''}
            classOverrides={`pl-0 text-xl pb-0.5 ${
              rules.length === 1 ? '' : 'hover:text-error-300'
            }`}
          >
            <i className="flex items-center ra-icons-generic-bin"></i>
          </Button>
        </div>
      </div>
      <div>
        <button onClick={() => addTarget(rule.id)}>
          <span className="underline text-sm">Add Condition Target</span>
        </button>
        {targets
          .filter((target) => target.rule_id === rule.id)
          .map((target) => {
            return (
              <SegmentationConfigRuleTarget
                key={`ruleid-${target.rule_id}-targetid-${target.target_id}`}
                target={target}
                targetTypeDropDownItems={targetTypeDropDownItems}
                operatorDropDownItems={operatorDropDownItems}
              />
            );
          })}
      </div>
    </div>
  );
}
